import { useMutation, useQueryClient } from '@tanstack/react-query';
import { keys } from '@/lib/queryKeys';
import { bookSlot } from './api';

/**
 * Not optimistic, unlike Queue's status update — booking has real server-side
 * rules that can reject it (the booking-cutoff-minutes check in
 * routes/appointment-slots.js's bookSlot, a slot someone else just took), so
 * mirrors the legacy await-then-refetch behaviour rather than risking a
 * flash-then-revert on a failure that is not a mere network fluke.
 *
 * queryKey uses the params-less appointments.slots() on purpose — see
 * useAppointmentSlots.ts and the Queue mutation this pattern is proven
 * against: TanStack's default partial-key matching treats {} as "no
 * constraint," so this invalidates every doctor/date/status variant
 * currently cached for the active branch, not just the one the screen
 * happens to be viewing right now.
 */
export function useBookSlot() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ slotId, patientId, rebookOfSlotId }: { slotId: number; patientId: number; rebookOfSlotId?: number }) =>
      bookSlot(slotId, { patient_id: patientId, ...(rebookOfSlotId ? { rebook_of_slot_id: rebookOfSlotId } : {}) }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: keys.appointments.slots() });
    },
  });
}
